var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cctv"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "smartlamp"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "headphone"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "headset"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "mouse"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "wireless_chip"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "gamepad"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "wireless_charge"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58,32c0-7.1-2.9-13.9-8-18.8V7.9C50,5.2,47.8,3,45.1,3H18.9C16.2,3,14,5.2,14,7.9v5.3C8.9,18.1,6,24.9,6,32    s2.9,13.9,8,18.8v5.3c0,2.7,2.2,4.9,4.9,4.9h26.2c2.7,0,4.9-2.2,4.9-4.9v-5.3C55.1,45.9,58,39.1,58,32z M8,32    c0-5.9,2.2-11.5,6-15.9v31.7C10.2,43.5,8,37.9,8,32z M48,56.1c0,1.6-1.3,2.9-2.9,2.9H18.9c-1.6,0-2.9-1.3-2.9-2.9V7.9    C16,6.3,17.3,5,18.9,5h26.2C46.7,5,48,6.3,48,7.9V56.1z M50,16.1c3.8,4.4,6,10,6,15.9s-2.2,11.5-6,15.9V16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,27.6C38.7,27.2,38.4,27,38,27h-3.1l1.7-4.6c0.1-0.3,0.1-0.7-0.1-0.9c-0.2-0.3-0.5-0.4-0.8-0.4h-7.5    c-0.5,0-0.9,0.3-1,0.8l-2.3,10c-0.1,0.3,0,0.6,0.2,0.8c0.2,0.2,0.5,0.4,0.8,0.4h2.4l-2.6,8.7c-0.1,0.5,0.1,0.9,0.5,1.2    c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.1,0.8-0.4l11.3-14C39,28.3,39.1,27.9,38.9,27.6z M29.2,37.4l1.5-5.1c0.1-0.3,0-0.6-0.2-0.9    c-0.2-0.3-0.5-0.4-0.8-0.4h-2.5l1.8-8h5.3l-1.7,4.6c-0.1,0.3-0.1,0.7,0.1,0.9c0.2,0.3,0.5,0.4,0.8,0.4h2.4L29.2,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8,44.1c-3.1,1.2-6.6,1.2-9.7,0c-0.5-0.2-1.1,0-1.3,0.6c-0.2,0.5,0,1.1,0.6,1.3c1.8,0.7,3.7,1.1,5.6,1.1    s3.8-0.4,5.6-1.1c0.5-0.2,0.8-0.8,0.6-1.3C37.9,44.1,37.3,43.9,36.8,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2,19.9c3.1-1.2,6.6-1.2,9.7,0c0.1,0,0.2,0.1,0.4,0.1c0.4,0,0.8-0.2,0.9-0.6c0.2-0.5,0-1.1-0.6-1.3    c-3.6-1.4-7.6-1.4-11.1,0c-0.5,0.2-0.8,0.8-0.6,1.3C26.1,19.9,26.7,20.1,27.2,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6,49c2.6,1.3,5.4,2,8.4,2s5.8-0.7,8.4-2c0.5-0.2,0.7-0.8,0.5-1.3c-0.2-0.5-0.8-0.7-1.3-0.4C37.2,48.4,34.6,49,32,49    c-2.6,0-5.2-0.6-7.5-1.7c-0.5-0.2-1.1,0-1.3,0.4C22.9,48.2,23.1,48.8,23.6,49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8,16.3c0.2-0.5,0-1.1-0.5-1.3c-2.6-1.3-5.4-2-8.4-2s-5.8,0.7-8.4,2c-0.5,0.2-0.7,0.8-0.4,1.3c0.2,0.4,0.5,0.6,0.9,0.6    c0.1,0,0.3,0,0.4-0.1c2.3-1.2,4.8-1.7,7.5-1.7c2.6,0,5.2,0.6,7.5,1.7C40,17,40.6,16.8,40.8,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1,50.4C39.1,52.1,35.6,53,32,53c-3.6,0-7.1-0.9-10.1-2.6c-0.5-0.3-1.1-0.1-1.4,0.4c-0.3,0.5-0.1,1.1,0.4,1.4    C24.3,54,28.1,55,32,55c3.9,0,7.7-1,11.1-2.9c0.5-0.3,0.7-0.9,0.4-1.4C43.2,50.3,42.6,50.1,42.1,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,11.9C39.7,10,35.9,9,32,9c-3.9,0-7.7,1-11.1,2.9c-0.5,0.3-0.7,0.9-0.4,1.4c0.3,0.5,0.9,0.7,1.4,0.4    C24.9,11.9,28.4,11,32,11c3.6,0,7.1,0.9,10.1,2.6c0.2,0.1,0.3,0.1,0.5,0.1c0.4,0,0.7-0.2,0.9-0.5C43.8,12.7,43.6,12.1,43.1,11.9z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "camera"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "printer"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "laptop"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "smartphone"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "smartwatch"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "speaker"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "drone"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "smart_plug"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "router"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "smart_lock"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "air_conditioner"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "smartglasses"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmart);
export default __webpack_public_path__ + "static/media/smart.fc8c04f724cb288eafa70fdd54a274b8.svg";
export { ForwardRef as ReactComponent };